import { useField } from 'react-final-form';

import { Hint } from 'CorePackage/MainModule/components/Hint';
import {
  LINK_PRESCRIPTIONS_FIELD,
  TPrescriptionRow,
} from 'KnmErknmPackage/ErknmEventSubjectModule/components/Links/functions/prescriptions';

const SELECT_PRESCRIPTION_MESSAGE = 'Выберите предписание';

/**
 * Уведомление для разделов "Предмет КНМ" и "Сведения об объектах контроля".
 */
export const SelectPrescriptionNotice = () => {
  const { input } = useField<TPrescriptionRow[]>(LINK_PRESCRIPTIONS_FIELD, { subscription: { value: true } });
  const rows: TPrescriptionRow[] = Array.isArray(input.value) ? input.value : [];

  if (!rows.length || rows.some(Boolean)) return null;

  return <Hint text={SELECT_PRESCRIPTION_MESSAGE} variant="alert" />;
};
